import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SettingsState {
  /** Dark Mode — Default: false (Light) */
  darkMode: boolean;
  /** Sound — Default: false (aus, für Schul-Räume) */
  soundEnabled: boolean;
  toggleDarkMode: () => void;
  toggleSound: () => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      darkMode: false,
      soundEnabled: false,
      toggleDarkMode: () => set((s) => ({ darkMode: !s.darkMode })),
      toggleSound: () => set((s) => ({ soundEnabled: !s.soundEnabled })),
    }),
    { name: 'seva-lernspiele-settings' },
  ),
);
